import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AlliesComponent } from './components/allies/allies.component';
import { environment } from '@environment/environment';


const routes: Routes = [
  {
    path: '',
    component: AlliesComponent,
    data: {
      meta: {
        robots: environment.statusMetaGeneric
      }
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AlliesRoutingModule { }
